import * as React from "react";
import { Table, TableRow, TableCell } from "@material-ui/core";
import { TableHead, TableBody } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import Totales from "./Totales";

const styles = () => ({
  cellHead: {
    backgroundColor: "#128bcc",
    border: "5px solid #fff",
    color: "#fff",
  },
  table: {
    marginTop: "50px",
  },
});

const Detalles = ({ documento, detalles = [], classes }) => {
  const getPorcentajeTributo = ({ impuestosRetenciones }, tributo) => {
    const imp = (impuestosRetenciones || []).filter(
      (ir) => ir.tributo === tributo
    )[0];
    return imp ? imp.porcentaje : 0;
  };

  const getValorDescuento = ({ cargosDescuentos }) => {
    const descuento = cargosDescuentos && cargosDescuentos[0];
    return descuento ? descuento.valor : 0;
  };

  return (
    <>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.cellHead}>Nro</TableCell>
            <TableCell className={classes.cellHead}>Código</TableCell>
            <TableCell className={classes.cellHead}>Descripción</TableCell>
            <TableCell className={classes.cellHead}>U.M.</TableCell>
            <TableCell className={classes.cellHead}>Cantidad</TableCell>
            <TableCell className={classes.cellHead}>Valor Unitario</TableCell>
            <TableCell className={classes.cellHead}>% IVA</TableCell>
            <TableCell className={classes.cellHead}>% INC</TableCell>
            <TableCell className={classes.cellHead}>Descuento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detalles.map((detalle, key) => (
            <TableRow key={key}>
              <TableCell>{parseInt(key) + 1}</TableCell>
              <TableCell>{detalle.codigoArticulo}</TableCell>
              <TableCell>{detalle.descripcionArticulo}</TableCell>
              <TableCell>{detalle.unidadMedida}</TableCell>
              <TableCell>{detalle.cantidad}</TableCell>
              <TableCell>{detalle.precioUnitario}</TableCell>
              <TableCell>{getPorcentajeTributo(detalle, "IVA")}</TableCell>
              <TableCell>{getPorcentajeTributo(detalle, "INC")}</TableCell>
              <TableCell>{getValorDescuento(detalle)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Totales documento={documento} classes={classes} />
    </>
  );
};

export default withStyles(styles)(Detalles);
